import { render, staticRenderFns } from "./IfVariable.vue?vue&type=template&id=bff7479a&"
import script from "./IfVariable.vue?vue&type=script&lang=js&"
export * from "./IfVariable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports